
export function register() {
    //if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    if ('serviceWorker' in navigator) {
        //const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
        window.addEventListener('load', function() {
            navigator.serviceWorker.register('/sw.js', {scope: "/"}).then(function(registration) {
                // Registration was successful
                // console.log('ServiceWorker registration successful with scope: ', registration.scope);
            }, function(err) {
                // registration failed :(
                // console.log('ServiceWorker registration failed: ', err);
            });
        });
    }
}
